module.exports = __webpack_public_path__ + "static/media/optilume_ambassador_8.3c54ed6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/optilume_ambassador_8.png
// module id = 103
// module chunks = 0